export function formatStock(pieces, piecesPerPack, packsPerBox) {
  if (pieces == null) return '0 pieces';
  if (piecesPerPack && packsPerBox) {
    const perBox = piecesPerPack * packsPerBox;
    const boxes = Math.floor(pieces / perBox);
    const afterBoxes = pieces % perBox;
    const packs = Math.floor(afterBoxes / piecesPerPack);
    const pcs = afterBoxes % piecesPerPack;
    const parts = [];
    if (boxes > 0) parts.push(`${boxes} box${boxes > 1 ? 'es' : ''}`);
    if (packs > 0) parts.push(`${packs} pack${packs > 1 ? 's' : ''}`);
    if (pcs > 0) parts.push(`${pcs} piece${pcs > 1 ? 's' : ''}`);
    return parts.length > 0 ? parts.join(', ') : '0 pieces';
  }
  return `${pieces} piece${pieces !== 1 ? 's' : ''}`;
}

export function formatStockShort(pieces, piecesPerPack, packsPerBox) {
  if (pieces == null) return '0';
  if (piecesPerPack && packsPerBox) {
    const perBox = piecesPerPack * packsPerBox;
    const boxes = Math.floor(pieces / perBox);
    const afterBoxes = pieces % perBox;
    const packs = Math.floor(afterBoxes / piecesPerPack);
    const pcs = afterBoxes % piecesPerPack;
    const parts = [];
    if (boxes > 0) parts.push(`${boxes}B`);
    if (packs > 0) parts.push(`${packs}Pk`);
    if (pcs > 0) parts.push(`${pcs}Pc`);
    return parts.length > 0 ? parts.join(' ') : '0';
  }
  return `${pieces}`;
}

export function getUnitLabel(unit) {
  switch (unit) {
    case 'PIECE': return 'Piece';
    case 'HALF_PACK': return 'Half Pack';
    case 'FULL_PACK': return 'Full Pack';
    case 'BOX': return 'Box';
    default: return 'Piece';
  }
}

export function getUnitPrice(product, unit) {
  switch (unit) {
    case 'PIECE': return product.salePrice || 0;
    case 'HALF_PACK': return product.pricePerHalfPack || 0;
    case 'FULL_PACK': return product.pricePerFullPack || 0;
    case 'BOX': return product.pricePerBox || 0;
    default: return product.salePrice || 0;
  }
}

export function getPiecesForUnit(unit, qty, piecesPerPack, packsPerBox) {
  switch (unit) {
    case 'PIECE': return qty;
    case 'HALF_PACK': return qty * Math.ceil((piecesPerPack || 1) / 2);
    case 'FULL_PACK': return qty * (piecesPerPack || 1);
    case 'BOX': return qty * (piecesPerPack || 1) * (packsPerBox || 1);
    default: return qty;
  }
}
